import { Environment } from '../types/environment';

export const environment: Environment = {
  production: false,
  stage: 'staging',
  apiUrl: 'https://stg.api.login.inteligenciadevida.tec.br/api',
  cypherSecret: '67eb50c71323d36016247bd9ecb4879d',
  oauth: {
    callbackPath: '/auth/callback',
    providers: {
      atlasId: {
        clientId: '3ec869d8-8cdc-4d50-afff-0d4b9115da2c',
        issuer: 'https://id.gruposaltaedu.com/'
      },
      google: {
        clientId:
          '209650852772-dvbrdm20u6i86rjqr70gvjjddbi3dcj5.apps.googleusercontent.com',
        issuer: 'https://accounts.google.com',
        scope: 'openid profile email'
      },
      microsoft: {
        clientId: '',
        issuer: 'https://login.microsoftonline.com/common/v2.0',
        scope: 'openid profile email'
      }
    }
  }
};
